import React, { useEffect, useState } from 'react';
import { Line } from "react-chartjs-2";
import { duesCleaner, getSettlementDues } from "../../features/EUA/EuaSlice";
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton, Input, Space } from 'antd';
import ExpandableTable from '../ExpandableTable';

const { Search } = Input;
const EmissionTrend = ({ data, voyageYear }) => { const dispatch = useDispatch();
  const { status: euaStatus } = useSelector((state) => state.eua);

  const { dues } = useSelector((state) => state.eua);


  // Fetch settlement dues when voyageYear changes
  useEffect(() => {
    dispatch(getSettlementDues(voyageYear || 2025));
  }, [dispatch, voyageYear]);

  // Search handler — searches by vessel/casper keyword, keeps current year
  let timeoutId;
  const onSearch = (event) => {
    dispatch(duesCleaner());
    clearTimeout(timeoutId);
    const keyword = event.target.value;
    timeoutId = setTimeout(() => {
      dispatch(getSettlementDues(keyword || voyageYear || 2025));
    }, 500);
  };

  const voyageTrack = dues?.voyage_track || [];

  // Emission trend chart data (you can customize this with real data)
  const emissionTrendData = {
    labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
    datasets: [
      {
        label: "Verified Emissions (KT)",
        data: [820, 840, 860, 850, 870, 865, 880, 890, 895, 885, 875, 900, 910, 920],
        borderColor: "#1677ff",
        backgroundColor: "rgba(22, 119, 255, 0.1)",
        tension: 0.4,
        fill: true,
      
      },
      {
        label: "EUAs Price (€)",
        data: [1800, 1850, 1820, 1900, 1880, 1920, 1950, 1940, 1960, 1930, 1910, 1980, 1990, 2000],
        borderColor: "#fa8c16",
        backgroundColor: "rgba(250, 140, 22, 0.1)",
        tension: 0.4,
        fill: true,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
    scales: {
      y: {
        beginAtZero: false,
      },
    },
  };

  const RenderTable = () => {
    if (dues === null) {
      return <Skeleton />;
    }
    return <ExpandableTable data={dues} loading={euaStatus === "loading"} />;
  };

  return (
    <div className="emission-trend-section">
      {/* <h3 className="section-title">Emission Trend</h3> */}
      
      {/* Chart */}
      {/* <div className="chart-contains" style={{ height: "300px", marginBottom: "30px" }}>
        <Line data={emissionTrendData} options={chartOptions} />
      </div> */}

      {/* Settlement Table Section - INSIDE EmissionTrend */}
      <div className='ettop' style={{ marginTop: "30px" }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          marginBottom: '16px'
        }}>
          <h4>ETS & FEUM Exposure</h4>
          
          <Space direction="vertical">
            <Search
              placeholder="Search Vessel Name, Casper ID"
              bordered={true}
              onChange={onSearch}
              allowClear
              style={{ width: 310 }}
            />
          </Space>
        </div>
        
        {RenderTable()}
      </div>
    </div>
  );
};

export default EmissionTrend;